export const countriesTax = ['US', 'CA'];

export const isCountriesTax = (country) => (countriesTax.includes(country));
